module.exports = __webpack_public_path__ + "img/tag8.cddfe03f.png";